import React from 'react';
import PropTypes from 'prop-types';
import {RichText} from 'prismic-reactjs';

import {Box, ButtonGroup} from '@spothero/ui';

import {RICHTEXT_PROP_TYPES, CTA_BUTTON_PROP_TYPES} from 'cms/proptypes';
import {
    bodySerializer,
    headingSerializer,
    ignoreEmptyRichTextObjects,
    getSliceThemeVariables,
} from 'cms/utils';
import ExtendedButton from 'cms/components/extended-button';

const HeroTextBlock = ({
    pageTitle,
    heroSecondaryTitle,
    heroText,
    items,
    sliceTheme,
}) => {
    const hasSecondaryTitle =
        ignoreEmptyRichTextObjects(heroSecondaryTitle).length > 0;
    const {
        primaryButtonVariant,
        secondaryButtonVariant,
        primaryHeadingTextColor,
        secondaryHeadingTextColor,
        linkVariant,
    } = getSliceThemeVariables(sliceTheme);

    const ctaButtons = items
        .slice(0, 2)
        .filter(button => button.cta_text)
        .map((button, i) =>
            ExtendedButton({
                buttonText: button.cta_text,
                inPageAnchor: button.in_page_anchor,
                key: i,
                link: button.cta_external_link.url,
                linkTarget: button.cta_external_link.target,
                variant:
                    i === 0 ? primaryButtonVariant : secondaryButtonVariant,
                marginY: 2,
            })
        );

    return (
        <>
            <RichText
                render={pageTitle}
                htmlSerializer={headingSerializer(
                    hasSecondaryTitle ? 'h3' : 'h1',
                    {
                        color: hasSecondaryTitle
                            ? primaryHeadingTextColor
                            : secondaryHeadingTextColor,
                        marginBottom: hasSecondaryTitle ? 4 : 6,
                    }
                )}
            />
            {hasSecondaryTitle ? (
                <RichText
                    render={heroSecondaryTitle}
                    htmlSerializer={headingSerializer('h1', {marginBottom: 6})}
                />
            ) : null}
            <Box textAlign="left">
                <RichText
                    render={ignoreEmptyRichTextObjects(heroText)}
                    htmlSerializer={bodySerializer({
                        linkVariant,
                    })}
                />
            </Box>
            {ctaButtons.length ? (
                <ButtonGroup
                    alignContent="space-between"
                    justifyContent="center"
                    flexWrap={{base: 'wrap', mobileXL: 'nowrap'}}
                    spacing={{base: 2, tablet: 4}}
                >
                    {ctaButtons}
                </ButtonGroup>
            ) : null}
        </>
    );
};

HeroTextBlock.propTypes = {
    sliceTheme: PropTypes.string.isRequired,
    pageTitle: RICHTEXT_PROP_TYPES.isRequired,
    heroSecondaryTitle: RICHTEXT_PROP_TYPES.isRequired,
    heroText: RICHTEXT_PROP_TYPES.isRequired,
    items: PropTypes.arrayOf(CTA_BUTTON_PROP_TYPES),
};

export default HeroTextBlock;
